var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MountingPortal',{attrs:{"mount-to":"body","append":""}},[_c('div',{staticClass:"overlay",class:{ showNavigation: _vm.showNavigation }},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }